import React, { useContext, useState, useEffect } from 'react';
import { Link, navigate } from 'gatsby';
import { FiSearch } from 'react-icons/fi'; // Importa FiSearch desde Feather Icons
import AvatarHeader from '@components/header/Avatar';
import { UserDataContext } from '@context/userContext';
import Drawer from '@components/drawer/Drawer';

const Header = ({ showBottomBorder = false }) => {
  const userData = useContext(UserDataContext);
  const { drawerCart, setDrawerCart } = userData;

  // Añade un estado para controlar el valor del buscador
  const [searchValue, setSearchValue] = useState('');
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(20);

  useEffect(() => {
    let windowWidth = window.innerWidth;
    setWidth(windowWidth);
    if (windowWidth < 600) {
      setHeight(120)
    } else {
      setHeight(80)
    }
  }, [])

  const handleSearch = () => { 
    if (searchValue.trim().length > 0) {
      navigate('/buscar/' + searchValue.trim())
    }
  };

  return (
    <nav className="fixed top-0 z-50 flex w-full flex-col items-center justify-center bg-[#F6FFF2] px-4 drop-shadow-md xs:px-10 md:px-5" style={{height: height}}>
      <aside
        className={`${
          drawerCart
            ? ' translate-x-0 transition duration-300 ease-in-out'
            : ' translate-x-[100rem] transition duration-300 ease-in-out'
        } absolute right-0 top-0 z-10 flex h-screen w-[100%] justify-center bg-[#F6FFF2] shadow-md drop-shadow-md sm:w-[60%] lg:w-[40%] 2xl:w-[30%]`}
      >
        <Drawer />
      </aside>

      <div
        className={`${
          drawerCart
            ? 'opacity-100 transition duration-300 ease-in-out sm:w-[40%] lg:w-[60%] 2xl:w-[70%]'
            : 'w-0 opacity-0 transition duration-300 ease-in-out'
        } absolute left-0 top-0 z-10 h-screen bg-black bg-opacity-30`}
        onClick={() => setDrawerCart(!drawerCart)}
      />

      <div className="container relative flex items-center justify-between w-full">
        <div className="flex items-center">
          <Link to="/">
            <img
              src="https://cdn.mercadodeflores.pe/mercado-de-flores.png"
              alt="Logo"
              title="Mercado de flores"
              className="w-28 xs:w-40"
            />
          </Link>
        </div>
        {width >= 600 &&
          <div className="flex flex-row gap-2 lg:gap-3 justify-center"> 
            <div className="relative w-full max-w-md"> 
              <input
                type="text"
                placeholder="Busca tu próximo detalle..."
                className="pl-10 pr-2  py-2 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 w-96"
                value={searchValue} 
                onChange={(e) => setSearchValue(e.target.value)} 
                onKeyPress={(e) => { if (e.key === 'Enter') { handleSearch(); } }} 
              />
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FiSearch className="text-gray-500" />
              </div>
            </div>
            <button
              onClick={() => handleSearch()}
              className={`px-4 py-2 rounded-full border border-gray-300 ${
                searchValue ? 'bg-success text-white' : 'bg-[#EFEFEF] hover:bg-[#D9D9D9] active:bg-[#EBEBEB]'
              } font-medium transition-colors duration-300`}
            >
              Buscar
            </button>
          </div>
        }
        <div className="flex md:pr-5">
          <AvatarHeader />
        </div>
      </div>
      {width < 600 &&
        <div className="flex flex-row gap-2 lg:gap-3 justify-center mt-2" style={{width: '100%'}}> 
          <div className="relative w-full max-w-md"> 
            <input
              type="text"
              placeholder="Busca tu próximo detalle..."
              className="pl-10 pr-2 py-2 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 w-full"
              value={searchValue} 
              onChange={(e) => setSearchValue(e.target.value)} 
              onKeyPress={(e) => { if (e.key === 'Enter') { handleSearch(); } }} 
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <FiSearch className="text-gray-500" />
            </div>
          </div>
          <button
            onClick={() => handleSearch()}
            className={`px-4 py-2 rounded-full border border-gray-300 ${
              searchValue ? 'bg-success text-white' : 'bg-[#EFEFEF] hover:bg-[#D9D9D9] active:bg-[#EBEBEB]'
            } font-medium transition-colors duration-300`}
          >
            Buscar
          </button>
        </div>
      }
      {showBottomBorder && <span className="absolute bottom-0 h-1 w-full bg-primary" />}
    </nav>
  );
};

export default Header;
